/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class EmployeeTerminateController {
    public static $inject = [
        '$state',
        'Employee',
        'User',
        'bsLoadingOverlayService',
        'toaster'
    ];

    public employee;
    public checkPermission;
    public terminate_reason;
    public terminate_date;
    public tDate;
    public datePickerConfig;


    constructor(private $state: angular.ui.IStateService,
                private Employee: IEmpService,
                private User: IUserService,
                private bsLoadingOverlayService: IBsLoadingService,
                private toaster: any) {

        document.body.scrollTop = document.documentElement.scrollTop = 0;

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false
        };

        if (!User.hasPermission('org.change_org')) {
            $state.go('^');
        }

        bsLoadingOverlayService.start({ referenceId: 'terminate_loader'});

        Employee.loadEmployee($state.params['id']).then((response: Restangular.IResponse) => {
            this.employee = response;
            this.employee.extra.image = this.employee.extra.image && this.employee.extra.image !== '/static/images/placeholder-nobody2.png' ? this.employee.extra.image : '/static/images/placeholder-nobody2.png'
            bsLoadingOverlayService.stop({ referenceId: 'terminate_loader'});
        });
    }

    public terminate() {
        if (!this.terminate_reason || this.terminate_reason == '') {
            this.toaster.pop('warning', 'Validation Failed', 'Please enter a reason for termination');
            return false;
        }

        if (!this.terminate_date || this.terminate_date == '') {
            this.toaster.pop('warning', 'Validation Failed', 'Please enter a termination date');
            return false;
        } else {
            this.tDate = moment(this.terminate_date).format('YYYY-MM-DD');
        }

        this.bsLoadingOverlayService.start({ referenceId: 'terminate_loader'});
        this.Employee.terminate(this.employee, this.terminate_reason, this.tDate).then(() => {
            this.toaster.pop('success', 'Success', 'Employment Terminated');
            this.bsLoadingOverlayService.stop({ referenceId: 'terminate_loader'});
            this.$state.go('root.employees');

        }, (response) => {
            this.toaster.pop('error', 'Error', response.data);
            this.bsLoadingOverlayService.stop({ referenceId: 'terminate_loader'});
        });
    }

}

angular.module('beneple.employees')
    .controller('EmployeeTerminateController', EmployeeTerminateController);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-terminate.controller.ts